import React, { useContext } from 'react';
import { Handle, NodeProps, Position } from 'reactflow';
import { Box } from '@mui/material';
import styles from './styles';
import IntentTreeNode from '../../../../types/BotBuilder/IntentTreeNode';
import BotBuilderNode from '../BotBuilderNode/BotBuilderNode';
import BotResponseTreeNode from '../../../../types/BotBuilder/BotResponseTreeNode';
import BotBuilderContext from '../../../../context/BotBuilderContext/BotBuilderContext';
import SlotTokenRenderer from '../ResponseNode/ResponseBlock/SlotTokenRenderer';

export type IntentNodeData = {
  node: BotResponseTreeNode;
  onNodeUpdate: (node: BotResponseTreeNode) => void;
  isLocked?: boolean;
};

function IntentNode(props: NodeProps<IntentNodeData>): React.ReactElement {
  const { data, isConnectable } = props;
  const { onNodeUpdate } = useContext(BotBuilderContext);

  const isIntentTreeNode = (content: any): content is IntentTreeNode => {
    return content instanceof IntentTreeNode;
  };

  const intentContent = isIntentTreeNode(data.node.content)
    ? data.node.content
    : null;

  const utterance = intentContent?.sampleUtterances[0] || null;

  const handleNodeAdd = (newNode: BotResponseTreeNode) => {
    if (intentContent) {
      intentContent.nextStep = newNode;
      onNodeUpdate(data.node);
    }
  };

  return (
    <BotBuilderNode
      title='Visitor says:'
      sourceNode={data.node}
      onNodeAdd={handleNodeAdd}
      showAddButton={!intentContent?.nextStep}
      isLocked={data.isLocked}
    >
      {utterance && (
        <Box sx={styles.intentContainer}>
          <SlotTokenRenderer>{utterance}</SlotTokenRenderer>
        </Box>
      )}
      <Handle
        type='source'
        position={Position.Bottom}
        id='b'
        style={{ bottom: -10 }}
        isConnectable={isConnectable}
      />
    </BotBuilderNode>
  );
}

export default IntentNode;
